// src/components/jb-svg/jb-svg.custom.ts
var animationNames = [
  "EXPAND",
  "MOVE_RIGHT",
  "MOVE_LEFT",
  "MOVE_UP",
  "MOVE_DOWN",
  "TILT",
  "ROTATE",
  "NONE"
];
var iconNames = [
  "ARROW_DOWN",
  "ARROW_LEFT",
  "ARROW_RIGHT",
  "ARROW_UP",
  "CHEVRON",
  "DOWNLOAD",
  "EMAIL_TEMPLATE",
  "EXTERNAL",
  "FILE_EXCEL",
  "FILE_PDF",
  "FILE_POWERPOINT",
  "FILE_WORD",
  "FILE",
  "IN_PAGE",
  "INTERNAL",
  "MAIL",
  "NEWS",
  "POLICIES",
  "SHAREPOINT_PAGE",
  "WEB_PAGE"
];

export {
  animationNames,
  iconNames
};
